import config from 'veui/managers/config'

config.defaults(
  {
    parts: {
      shortcuts: 'text s',
      dayPicker: 's',
      tooltip: 's'
    }
  },
  'schedule'
)
